import { Component, OnInit } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  templateUrl: './cleanster.component.html',
})
export class CleansterComponent implements OnInit {
  public AppPermission = AppPermission;
  constructor() { }

  ngOnInit(): void { }
}
